export default __webpack_public_path__ + "static/meeting-e63e4edf52a2c86f877bdddcccff5b90.jpg";